<template>
  <div class="container-fluid">
    <transition :css="false">
    <el-dialog title="Add Sms" :visible.sync="showModal" width="40%">
    <form >
          <p v-show="errorGroup" class="text-danger text-center font-weight-bold">Group Name and Phone Numbers are required!</p>

          <arnergy-dynamic
            v-model="form.groupID"
            label="Select Group"
            :items="groups"
            @subgroup="getSubgroupss"
          />
          <arnergy-select
            v-model="form.subgroup"
            label="Subgroup"
            :items="subgroups"
          />
          <br />

          <div class="d-flex justify-content align-items-center">
            <input
              type="number"
              v-model="phone"
              style="width: 100%; height: 4rem;"
            />
            <button
              class="btn btn-primary"
              style="height: 4rem;"
              @click="addField"
            >
              Add
            </button>
          </div>

          <br />
          <div>
            <p>Phone Numbers Selected</p>
            <div class="">
              <div v-for="item in phoneNumbers" :key="item.phone">
                <div class="d-flex justify-content-between">
                  <div class="pb-3">{{ item.phone }}</div>
                  <div class="text-danger" @click="removeField(item.phone)" style="cursor: pointer">
                    Remove
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pt-4 text-right">
            <div v-if="loader" className="text-center">
              <div class="submit-gif">
                <div
                  class="spinner-border"
                  style="width: 3rem; height: 3rem;"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div v-else>
              <button class="btn btn-primary" @click="smsFunc">Submit</button>
            </div>
          </div>
        </form>
    </el-dialog>
    </transition>

    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>New User</h3>
        <hr />
      </div>
    </vk-offcanvas>
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">SMS</h2>
        <can I="create" a="user">
          <span style="display: flex; align-items: center;">
            <button
              class="btn btn-primary"
              to="/user/new"
              @click="showModal = true"
            >
              New SMS
            </button>
          </span>
        </can>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <can I="read" a="user">
              <Users />
            </can>
            <el-tabs v-model="activeTab">
              <!-- <can I="read" a="user">
                <el-tab-pane label="User List" name="user_list">
                  <Users/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="device">
                <el-tab-pane label="User Devices" name="user_devices">
                  <Devices/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="wallet">
                <el-tab-pane label="Transaction History" name="transaction_history">
                  <transaction-histories/>
                </el-tab-pane>
              </can>-->
              <!-- <can I='read' a='user'>
                  <el-tab-pane title="User Role Management">
                  <user-role/>
                  </el-tab-pane>
              </can>-->
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Users from '../user-mgt/SmsInfo'
import Devices from '../devices/List'
import transactionHistories from '../shs/Wallet'
import userRole from '../users/allow'
import ModalMain from '../kitchen/Onboarding/ModalMain.vue'
import ArnergyInput from '../kitchen/ArnergyInput.vue'
import ArnergySelect from '../kitchen/ArnergySelect.vue'
import { mapGetters } from 'vuex'
import VueSweetalert2 from 'vue-sweetalert2'
import ArnergyDynamic from '../kitchen/AnergySelectDynamic.vue'
import Vue from 'vue'
import 'sweetalert2/dist/sweetalert2.min.css'

import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
  // ...
} from 'element-ui'

import { Offcanvas, OffcanvasClose } from 'vuikit/lib/offcanvas'

export default {
  name: '',
  components: {
    'vk-offcanvas': Offcanvas,
    'vk-offcanvas-close': OffcanvasClose,
    'el-autocomplete': Autocomplete,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-radio': Radio,
    'el-radio-group': RadioGroup,
    'el-radio-button': RadioButton,
    Users,
    Devices,
    transactionHistories,
    userRole,
    VueSweetalert2,
    ArnergyInput,
    ArnergySelect,
    ArnergyDynamic,
    ModalMain,
  },
  data() {
    return {
      showOffCanvas: false,
      activeTab: 'user_list',
      showModal: false,
      phoneNumbers: [],
      loader: false,
      phone: '',
      errorGroup: false,
      groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }],
      form: {
        groupID: '',
        subgroup: '',
      },
      groups: [
        { id: 'group1', name: 'group1' },
        { id: 'group2', name: 'group2' },
      ],
      formErrors: {
        name: '',
        description: '',
      },
    }
  },
  computed: {
    ...mapGetters([
      'getUserById',
      'getDeviceById',
      'getUsers',
      'getEmails',
      'getGroups',
      'getSubgroups',
      'getDummy',
      'getDevices',
    ]),
  },
  methods: {
    smsFunc(e) {
      e.preventDefault()
      const HTTP = this.$httpUtils.instance
      const data = {
        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        phonenumber: this.phoneNumbers,
      }

      console.log(data)
      if (data.groupid && data.phonenumber) {
        this.loader = true
        HTTP.post('/smsSetups/addPhoneNumber', data)
          .then((res) => {
            if (res.data) {
              this.showModal = false
              this.showAlert()
              this.loader = false
              this.fetchSms()
              this.phoneNumbers = []
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
this.errorGroup = true;
        setTimeout(() => this.errorGroup = false, 1500);
      }
    },
    addField(e) {
      e.preventDefault()
      if (this.phone) {
        this.phoneNumbers.push({ phone: this.phone })
        this.phone = ''
      }
      console.log(this.phoneNumbers)
    },
    removeField(phone) {
      if (phone) {
        this.phoneNumbers.splice(
          this.phoneNumbers.findIndex((e) => e.phone === phone),
          1,
        )
      }
      console.log(this.phoneNumbers)
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: 'Success',
        imageWidth: '40px',
        text: 'Sms Set Up Successfully',
        icon: 'success',
        width: '550px',
      })
    },
    async getSubgroupss(id) {
      const HTTP = this.$httpUtils.instance
      let formData = new FormData()
      formData.append('groupid', id)
      let res = await HTTP.post(
        '/customerSubGroups/getCustomerSubGroupByGroupId',
        formData,
      )
        .then((res) => {
          this.subgroups = res.data
            .map((item) => {
              return {
                id: item.id,
                name: item.subgroupname,
              }
            })
            .sort((a, b) => {
              return a.name > b.name ? 1 : -1
            })
        })
        .catch((e) => {
          //
        })
      // parse for "arnergy-select" us
    },
    fetchSms() {
      const HTTP = this.$httpUtils.instance
      //  filter={"include": ["installations"]}
      const url = `/smsSetups
`
      HTTP.post(url)
        .then((response) => {
          const list = response.data
          this.$store.commit(
            'saveSms',
            list.map((data) => ({
              id: data.id,
              groupname: data.groupname,
              subgroupname: data.subgroupname,
              phonenumber: data.phonenumber,

              status: data.status === 0 ? 'Disabled' : 'Enabled',
            })),
          )

          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
  },
  async mounted() {
    // console.log(this.phoneNumbers)
    this.groups = this.getGroups
      .map((item) => {
        return {
          id: item.id,
          name: item.groupname,
        }
      })
      .sort((a, b) => {
        return a.name > b.name ? 1 : -1
      })
  },
}
</script>

<style lang="scss" scoped>
.close-btn {
  color: orangered;
  font-size: 16px;
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/user-mgt/Sms.vue